import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_SUGGEST_REQUEST } from './schema';

const QUERY = gql`
  query GetMultiPromptRunner($projectId: ID!, $chainId: ID, $csvChainId: ID) {
    getMultiPromptRunner(projectId: $projectId, chainId: $chainId, csvChainId: $csvChainId) {
      ...SuggestionRequest
    }
  }
  ${FRAGMENT_SUGGEST_REQUEST}
`;

export const getMultiPromptRunner = async ({ projectId, chainId, csvChainId }) => {
  const variables = {
    projectId,
    chainId,
    csvChainId,
  };

  const response = await executeGqlQuery({
    query: QUERY,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  return getSingleProp(response.data);
};
